$(document).ready(function () {
    // Cache DOM elements
    var sideMenu = $('#sideMenu');
    var navWrapper = $('.vb-mobile-nav-wrapper');
    var navContent = $('.vb-mobile-nav-content');
    var GobackBtn = $('#vb-mobile-all-nav');
    var burgerMenu = $('.vb_mobile_top_header .burger-menu');

    // Initialize hidden states
    sideMenu.addClass('hide-left');
    navContent.addClass('hide-right');
    GobackBtn.addClass('hide-right');

    // 1. Toggle Side Menu
    $('.vb_mobile_top_header').off('click').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // Toggle the burger menu icon
        burgerMenu.toggleClass('active');

        if (sideMenu.hasClass('show')) {
            // Hide side menu
            sideMenu.removeClass('show').addClass('hide-left');
            navContent.removeClass('show').addClass('hide-right');
            GobackBtn.addClass('hide-right').removeClass('show');
        } else {
            // Show side menu
            sideMenu.addClass('show').removeClass('hide-left');
            navContent.removeClass('show').addClass('hide-right');
            GobackBtn.addClass('hide-right').removeClass('show');
        }
    });

    // 2. Navigation Item Click (Show Specific Section)
    $('.nav-item').click(function () {
        var item = $(this).data('item');
        var section = $('.vb-mobile-nav-content[data-item-section="' + item + '"]');

        if (section.hasClass('show')) {
            // Hide the section and show the main menu
            section.removeClass('show').addClass('hide-right');
            navWrapper.removeClass('hide-left');
        } else {
            // Show the selected section and hide the main menu
            section.addClass('show').removeClass('hide-right');
            navWrapper.addClass('hide-left');
        }
    });

    // 3. Slide Back to Main Menu
    $('.slide-back').click(function () {
        navContent.removeClass('show').addClass('hide-right'); 
        navWrapper.removeClass('hide-left'); 
        GobackBtn.addClass('hide-right').removeClass('show');
    });

    // 4. Toggle View More / View Less
    window.VBtoggleVisibility = function (button) {
        var $extraItems = $(button).prev();
        if ($extraItems.hasClass('show__viewmore')) {
            $extraItems.removeClass('show__viewmore');
            $(button).html('View More');
        } else {
            $extraItems.addClass('show__viewmore');
            $(button).html('View Less');
        }
    };
});
